import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/sso-callback')({
  component: SsoCallbackPage,
})

function SsoCallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    void navigate({ to: '/', replace: true })
  }, [navigate])

  return null
}
